import { Injectable } from '@angular/core';
import { UserSettingsService } from '../user-settings/user-settings.service';
import * as SoundService from '../sound/sound.service';

@Injectable({
  providedIn: 'root',
})
export class SoundSettingsService {
  constructor(private userSettingsService: UserSettingsService) {
    this.userSettingsService.settings$.subscribe((settings) => {
      this.applySoundSettings(
        settings.sfxSoundsEnabled,
        settings.speechSoundsEnabled
      );
    });
  }

  public areSFXSoundsEnabled(): boolean {
    return this.userSettingsService.currentSettings.sfxSoundsEnabled;
  }

  public areSpeechSoundsEnabled(): boolean {
    return this.userSettingsService.currentSettings.speechSoundsEnabled;
  }

  public async enableSFXSounds(): Promise<void> {
    await this.userSettingsService.updateSetting('sfxSoundsEnabled', true);
  }

  public async disableSFXSounds(): Promise<void> {
    await this.userSettingsService.updateSetting('sfxSoundsEnabled', false);
  }

  public async enableSpeechSounds(): Promise<void> {
    await this.userSettingsService.updateSetting('speechSoundsEnabled', true);
  }

  public async disableSpeechSounds(): Promise<void> {
    await this.userSettingsService.updateSetting('speechSoundsEnabled', false);
  }

  private applySoundSettings(
    sfxEnabled: boolean,
    speechEnabled: boolean
  ): void {
    if (sfxEnabled) {
      SoundService.enableSFXSounds();
    } else {
      SoundService.disableSFXSounds();
    }

    if (speechEnabled) {
      SoundService.enableSpeechSounds();
    } else {
      SoundService.disableSpeechSounds();
    }
  }
}
